<template>
  <div class="">
    <swiper class="banner_swiper" :options="bannerOption" v-if="bannerList.length > 0">
      <swiper-slide v-for="(item, index) in bannerList" :key="index">
        <img style="width:100%;display: block;object-fit: cover; height: 500px" :src="item" alt="" >
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="banner_btn button-prev" slot="button-prev">
      </div>
      <div class="banner_btn button-next" slot="button-next">
      </div>
    </swiper>

    <div class="enroll_item">
        <Baywindow :opts="opts" @setByWindow="handleEnroll" v-if="detail.status === 1 && isShow==false"></Baywindow>
<!--        <div v-html="mainHTML" class="ql-editor inner" style="padding:0 20px;"></div>-->
        <MainDetail class="inner" :mainDetail="mainDetail" style="margin-top: 10px"></MainDetail>

        <div class="folat_box" v-if="detail.status === 1">
          <div class="float_item" @click="handleEnroll" v-if="!isShow"> <i class="el-icon-circle-plus"></i> 点击报名</div>
          <div class="float_item" @click="handleUpload" style="text-align: center">  <i class="el-icon-upload"></i> {{isZpShow ? '查看' : '上传'}}</div>
        </div>
        <el-dialog title="立即报名" center :close-on-click-modal="false"  :visible.sync="open" width="600px" append-to-body @closed="cancel">
            <el-form ref="form" :model="ruleForm" :rules="rules" label-width="100px">
                <el-form-item label="参赛方式：" prop="type">
                    <el-radio-group v-model="ruleForm.type">
                        <el-radio :label="0">个人</el-radio>
                        <el-radio :label="1">团队</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="ruleForm.type==1&&!isFound" label="团队名称：" prop="teamId" >
                    <el-select v-model="ruleForm.teamId" style="width:100%;" filterable placeholder="请选择">
                        <el-option
                        v-for="item in teamList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div style="line-height:1;text-align: right;">
                        <el-button type="text" size="mini" @click="handleFound">创建团队</el-button>
                    </div>
                </el-form-item>

                <el-form-item v-if="ruleForm.type==1&&isFound" label="团队名称：" prop="teamId">
                    <el-input v-model="teamName" placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="参赛姓名：" prop="nickName">
                    <span>{{ ruleForm.nickName }}</span>
                </el-form-item>
                <el-form-item label="系统账号：" prop="userName">
                    <span>{{ ruleForm.userName }}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm" :loading="ruleFormLoading">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
  </div>
</template>

<script>
import {getActivity} from '@/api/honour'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getToken } from '@/utils/auth'
import {listTeam,checkActivityUser, checkCertificate,postTeam,postCertificate,getSingUpStatus,getUpdateWorksStatus} from '@/api/online'
import Baywindow from '@/components/Baywindow'
import MainDetail from "@/components/MainDetail"
    export default {
        name:'EnrollItem',
        components:{Baywindow, MainDetail,swiper, swiperSlide},
        data(){
            return {
              isShow:true,
              isZpShow:null,
              bannerOption: {
                loop: true,
                autoplay: true,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
              },
              bannerList: [],
                mainHTML:'',
              mainDetail: {},
              detail: {},
              opts:{
                    step: 1,
                    delay: 18,
                    width: '264px',
                    height: '72px',
                    image:require('@/assets/images/go.png')
                },
                open:false,
                ruleForm:{
                    "activityId": '',
                    "userName": "",
                    "nickName": "",
                    "userId":'',
                    "type": 0,
                },
                rules:{},
                teamList:[],
                ruleFormLoading:false,
                teamName:'',
                isFound:false
            }
        },
        created(){
            const {id} = this.$route.params
            const {userName,nickName,userId} = this.$store.state.user.profile
            this.ruleForm.userName = userName
            this.ruleForm.nickName = nickName
            this.ruleForm.userId = userId
            this.ruleForm.activityId = id
            this.getActivity()
            this.listTeam()
            this.getSingUpStatus1()
            this.getUpdateWorksStatus()
        },
        methods:{
          getSingUpStatus1(){
            let userId=null
            if(getToken()){
              userId=this.$store.getters.userId
            }else {
              userId='-1'
            }
            getSingUpStatus(this.$route.params.id,userId).then(res=>{
              this.isShow=res.data
            })
          },
          getUpdateWorksStatus(){
            let userId=null
            if(getToken()){
              userId=this.$store.getters.userId
            }else {
              userId='-1'
            }
            getUpdateWorksStatus(this.$route.params.id,userId).then(res=>{
              this.isZpShow=res.data
            })
          },
            getActivity(){
                getActivity(this.$route.params.id).then(res=>{
                    this.bannerList=res.data.banner.split(",")
                    this.detail = res.data
                    this.mainDetail = res.data
                })
            },
            listTeam(){
                listTeam({activityId:this.$route.params.id,pageSize:1000,pageNum:1}).then(res=>{
                    console.log(res)
                    this.teamList = res.rows
                })
            },
            submitForm(){
                this.ruleFormLoading = true
                if(this.isFound){
                    postTeam({
                        "name": this.teamName,
                        "activityId": this.$route.params.id
                    }).then(res=>{
                        this.ruleForm.teamId = res.data.id
                        return postCertificate(this.ruleForm)
                    }).then(response=>{
                        this.$message.success('报名成功')
                      this.getActivity()
                      this.listTeam()
                      this.getSingUpStatus1()
                      this.getUpdateWorksStatus()
                    }).finally(()=>{
                        this.cancel()
                        this.ruleFormLoading = false
                    })
                }else{
                    postCertificate(this.ruleForm).then(res=>{
                        this.$message.success('报名成功')
                      this.getActivity()
                      this.listTeam()
                      this.getSingUpStatus1()
                      this.getUpdateWorksStatus()
                    }).finally(()=>{
                        this.cancel()
                        this.ruleFormLoading = false
                    })
                }
            },
            cancel(){
                this.ruleForm = {
                    "activityId": '',
                    "userName": "",
                    "nickName": "",
                    "userId":'',
                    "type": 0,
                }
                const {id} = this.$route.params
                const {userName,nickName,userId} = this.$store.state.user.profile
                this.ruleForm.userName = userName
                this.ruleForm.nickName = nickName
                this.ruleForm.userId = userId
                this.ruleForm.activityId = id
                this.open = false
            },
            handleFound(){
                this.isFound = true
            },
            handleEnroll(){
                checkActivityUser({activityId:this.$route.params.id}).then(res=>{
                    if(res.data){
                        this.open = true
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            handleUpload(){
                checkCertificate({activityId:this.$route.params.id}).then(res=>{
                    if(res.data){
                        this.$router.push({name:'MaterialUpload',params:{
                            id:this.$route.params.id
                        }})
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.folat_box{
    position: fixed;
    bottom: 500px;
    right: 20px;
  z-index: 999;
    .float_item{
        padding:20px 14px;
        background: #FFFFFF;
        border: 1px solid #E9E9E9;
        box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.04);
        cursor: pointer;
        i{
            display: block;
            text-align: center;
            font-size: 30px;
            color: #D81E07;
            margin-bottom: 2px;
        }
        &:first-of-type{
            border-bottom: none;
        }
    }
}
.enroll_item{
    img{
        width: 100%;
    }
}
</style>
